import { render, staticRenderFns } from "./ImportacaoHome.vue?vue&type=template&id=3d8a33f9"
import script from "./ImportacaoHome.vue?vue&type=script&lang=js"
export * from "./ImportacaoHome.vue?vue&type=script&lang=js"
import style0 from "./ImportacaoHome.vue?vue&type=style&index=0&id=3d8a33f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports